export default "__VITE_ASSET__BOg$HwED__"